"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNotificationTopicDto = instanceOfNotificationTopicDto;
exports.NotificationTopicDtoFromJSON = NotificationTopicDtoFromJSON;
exports.NotificationTopicDtoFromJSONTyped = NotificationTopicDtoFromJSONTyped;
exports.NotificationTopicDtoToJSON = NotificationTopicDtoToJSON;
exports.NotificationTopicDtoToJSONTyped = NotificationTopicDtoToJSONTyped;
/**
 * Check if a given object implements the NotificationTopicDto interface.
 */
function instanceOfNotificationTopicDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('required' in value) || value['required'] === undefined)
        return false;
    if (!('subscribed' in value) || value['subscribed'] === undefined)
        return false;
    return true;
}
function NotificationTopicDtoFromJSON(json) {
    return NotificationTopicDtoFromJSONTyped(json, false);
}
function NotificationTopicDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'required': json['required'],
        'subscribed': json['subscribed'],
    };
}
function NotificationTopicDtoToJSON(json) {
    return NotificationTopicDtoToJSONTyped(json, false);
}
function NotificationTopicDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'required': value['required'],
        'subscribed': value['subscribed'],
    };
}
//# sourceMappingURL=NotificationTopicDto.js.map